import { render, staticRenderFns } from "./matrixPerspective.vue?vue&type=template&id=7eb270d9&scoped=true"
import script from "./matrixPerspective.vue?vue&type=script&lang=js"
export * from "./matrixPerspective.vue?vue&type=script&lang=js"
import style0 from "./matrixPerspective.vue?vue&type=style&index=0&id=7eb270d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb270d9",
  null
  
)

export default component.exports